<app-header
  canvasMode="index"
  [loggedIn]="true"
  [canvasType]="canvasType"
  [fixedHeader]="true"
></app-header>

<div class="home-container">
  <h1 class="welcome-message">{{ canvasType }} Library</h1>
  <mat-tab-group
    class="HomeTab"
    animationDuration="0ms"
    disableRipple
    style="min-height: 400px"
  >
    <mat-tab label="Recent {{ canvasType }}s" id="recentTitle">
      <ng-template matTabContent>
        <app-carousel
          id="recentListing"
          [canvas_listing]="report_listing"
          [showCarousel]="showCarousel"
          [canvasType]="canvasType"
        ></app-carousel>
      </ng-template>
    </mat-tab>
    <mat-tab
      label="Favorite {{ canvasType }}s"
      [disabled]="!showFavCarousel"
      id="favoriteTitle"
    >
      <ng-template matTabContent>
        <app-carousel
          id="favoriteListing"
          [canvas_listing]="favorite_report_listing"
          [showCarousel]="showFavCarousel"
          [canvasType]="canvasType"
        ></app-carousel>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<div class="home-container" style="margin-top: 0px">
  <app-canvas-list
    [canvasType]="canvasType"
    [categories]="categories"
  ></app-canvas-list>
</div>
